import { render } from "./DetailComponent4Update.vue?vue&type=template&id=5ac58466&scoped=true"
import script from "./DetailComponent4Update.vue?vue&type=script&lang=js"
export * from "./DetailComponent4Update.vue?vue&type=script&lang=js"

import "./DetailComponent4Update.vue?vue&type=style&index=0&id=5ac58466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac58466"]])

export default __exports__